module.exports = __webpack_public_path__ + "static/media/cn.fa899156.svg";